"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _configurationContext = require("./configurationContext");
Object.keys(_configurationContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _configurationContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _configurationContext[key];
    }
  });
});
var _olapicDataContext = require("./olapicDataContext");
Object.keys(_olapicDataContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _olapicDataContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _olapicDataContext[key];
    }
  });
});
